import type { BuildingSchemaColumn } from "../../../ts-types/mapsTypes";

export type EditableFieldType = "text" | "numeric" | "money" | "dropdown";

export type EditableFieldConfig = {
  type: EditableFieldType;
  min?: number;
  max?: number;
  options?: { label: string; value: string }[];
};

/** The cell editor for a building schema column, or undefined when it isn't editable. */
export const columnEditorConfig = (column: BuildingSchemaColumn): EditableFieldConfig | undefined =>
  column.editor === null
    ? undefined
    : {
        type: column.editor,
        options: column.options?.map((option) => ({ value: String(option.value), label: option.label })),
      };

export const labelForEditableValue = (
  config: EditableFieldConfig | undefined,
  value: string | number | null,
): string | undefined => {
  if (value === null || value === "") return undefined;
  return config?.options?.find((option) => option.value === String(value))?.label;
};
